import { getField } from 'vuex-map-fields'

export const getters = {
  getField,
  loggedIn: state => !!state.token,
  accessTokenInfo: state => JSON.parse(state.token.access.split('.')[1]),
}
